import moment from "moment/moment"

export const sortAlphaNumeric = (list, key, ascending = true) => {
  return list.sort((itemA, itemB) => {
    if (itemA[key] > itemB[key]) {
      return ascending ? 1 : -1
    }
    if (itemA[key] < itemB[key]) {
      return ascending ? -1 : 1
    }

    return 0
  })
}

const parseValidity = (value) => moment(value, [moment.ISO_8601, 'DD.MM.YYYY'])

// valid_from is inclusive, valid_notafter (or valid_before) exclusive, like the backend's filter_by_validity
export const isValidAt = (version, now) => {
  const validBeforeRaw = version?.valid_before ?? version?.valid_notafter ?? null

  return (!version.valid_from || now.isSameOrAfter(parseValidity(version.valid_from))) &&
    (!validBeforeRaw || now.isBefore(parseValidity(validBeforeRaw)))
}

export const isCurrentlyValid = (version) => isValidAt(version, moment())

// Whether two validity windows [valid_from, valid_notafter) intersect; a missing bound is open
export const validityOverlaps = (a, b) => {
  const [aFrom, aUntil, bFrom, bUntil] = [a.valid_from, a.valid_notafter, b.valid_from, b.valid_notafter]
    .map(value => value ? parseValidity(value) : null)
  return (!aFrom || !bUntil || aFrom.isBefore(bUntil)) && (!bFrom || !aUntil || bFrom.isBefore(aUntil))
}

// valid_notafter is an exclusive bound. For display/editing we show the last day that is
// still valid: a bound at local midnight means the previous day was the last valid one.
export const lastValidDay = (validNotafter) => {
  if (!validNotafter) {
    return null
  }
  const end = parseValidity(validNotafter)
  return end.isSame(end.clone().startOf('day')) ? end.subtract(1, 'day') : end
}

// Inverse of lastValidDay for a date input value ('YYYY-MM-DD'): the exclusive bound, i.e. the
// start of the following day. Callers format it for their endpoint.
export const validNotafterFromLastDay = (lastDay) => {
  if (!lastDay) {
    return null
  }
  return moment(lastDay, 'YYYY-MM-DD').add(1, 'day').startOf('day')
}

export const getLatestVersion = (versions) => {
  if (!versions.length) {
    return null
  }

  if (versions.length === 1) {
    return versions[0]
  }

  const latestVersion = versions.find(version => {
    return isCurrentlyValid(version)
  })

  return latestVersion || versions[0]
}
